class ReadmissionsController {
  constructor($state, $scope, $q, $timeout, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, USER, CONST, materialButtons, datePicker, $rootScope, Constants, FunctionService) {

    this.datatableApi;
    this.name = 'Readmissions Within 28 Days';
    this.episodeValue = '';
    this.specialtyString = '';
    this.separationString = '';
    this.locale = 'en-au';
    this.startDatePicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
        dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
      }
    };
    this.endDatePicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, 'months').endOf('months'),
        dateFormatted: moment().locale(this.locale).subtract(1, 'months').endOf('months').format('L')
      }
    };
    this.url = WEBSERVICEURL + '/dataagility/api/service.readmissions?removeCoding=1';

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
        $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
      }
    );

    datePicker.autoClose($scope);

    materialButtons.render();

    materialButtons.processing();

    $scope.initCallback = function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {

      // Datatables has finished init
      // Initialise searching
      if ($scope.vm.datatableApi)
        return;

      $scope.vm.datatableApi = this.api();

      // Update column headers even when no data returned
      setDtHeaders($scope.vm.datatableApi);

      // tell DataTables we're using Aussie-formatted dates for ordering
      $.fn.dataTable.moment('DD/MM/YYYY HH:mm');

      // set the table to a fixed height, so it never collapsed up and down
      $('#auditTable').closest(".dataTables_scrollBody").height(300);

    }

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('ajax', {
        headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
        url: $scope.vm.url + '&startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted,
        type: 'GET',
        error: (xhr, error, thrown) => {
          if (thrown == 'Unauthorized') {
            //window.location.replace(window.location.origin + '/login');
            console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
        }
        }
      })
      .withDisplayLength(CONST.TABLEROWS)
      .withDataProp('data')
      .withOption('processing', true)
      .withOption('sAjaxDataProp', '')
      .withOption('bLengthChange', false)
      .withPaginationType('simple_numbers')
      .withOption('rowCallback', function (row, data, index) {
        // Update column headers if data returned
        setDtHeaders($('#auditTable').DataTable());
      })
      .withOption('drawCallback', $scope.drawCallback)
      .withOption('initComplete', $scope.initCallback)
      .withOption('scrollY', '300px')
      .withOption('scrollX', 'auto')
      .withOption('aaSorting', [
        [2, 'asc']
      ])
      .withOption('dom', '<"wrapper"rt<"table-footer"iBp>>')
      .withButtons([
        {
          extend: 'print',
          text: ''
        },
        {
          extend: 'csvHtml5',
          text: '',
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
        }, {
          extend: 'excelHtml5',
          text: '',
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
        }, {
          text: '',
          action: function (e, dt, node, config) {
            dt.ajax.reload();
          }
        }
      ]);

    //   .withColumnFilter({
    //     //sPlaceHolder: "head:after",
    //     aoColumns: [
    //       { type: 'number' },
    //       { type: "date-range" },
    //       { type: "date-range" },
    //       { type: "select" },
    //       { type: "select" },
    //       { type: "select" },
    //       { type: "number" }, {
    //         type: "text",
    //         bRegex: true,
    //         bSmart: true
    //       },
    //       { type: "number" }
    //     ]
    //   });

    // function yesNo(data) {
    //   return (data === true) ? "Y" : "N";
    // }

    this.dtColumns = [
      DTColumnBuilder.newColumn('urn').withTitle('UR Number').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('admissionDate').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('dischargeDate').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('auditCriteria').withTitle('Audit Criteria').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('status').withTitle('Audit Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('drg').withTitle('Original DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('finalDRG').withTitle('Final DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('wies').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric')
      .renderWith(function(data, type, full) {
        return (data ? parseFloat(data).toFixed(4) : '0.0000');
      }),
      DTColumnBuilder.newColumn('finalWIES').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric')
      .renderWith(function(data, type, full) {
        return (data ? parseFloat(data).toFixed(4) : '0.0000');
      }),
      DTColumnBuilder.newColumn('totalWIESChange').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric')
      .renderWith(function(data, type, full) {
        return (data ? parseFloat(data).toFixed(4) : '0.0000');
      }),
      DTColumnBuilder.newColumn('auditFinalisedDateTime').withTitle('Date Audit Finalised').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('patientClassification').withTitle('Patient Classification').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('healthCareFund').withTitle('Health Care Fund').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')
    ];

    // Search filters
    this.specialty = {
      selectedSpecialty: []
    };

    Constants.getDivisionAndSpecialtyData().then(
      function successCallback(response) {
        $scope.vm.specialtyOptions = response.specialties.sort();
      }
    );

    this.healthCareFund = {
      selectedHealthCareFund: []
    };

    Constants.healthCareFundData().then(
      function successCallback(response) {
        $scope.vm.healthCareFundOptions = response;
      }
    );

    this.patientClassification = {
      selectedPatientClassification: []
    };

    Constants.patientClassificationData().then(
      function successCallback(response) {
        $scope.vm.patientClassificationOptions = response;
      }
    );

    function setDtHeaders(table) {
      $(table.column(2).header()).html($scope.vm.separationString + ' Date');
      $(table.column(3).header()).html($scope.vm.specialtyString);
      $(table.column(8).header()).html('Original ' + $scope.vm.episodeValue);
      $(table.column(9).header()).html('Final ' + $scope.vm.episodeValue);
      $(table.column(10).header()).html($scope.vm.episodeValue + ' Change');
    }

    // Re-draw table on datepicker close
    $scope.$on('lx-date-picker__close-start', function(e, id) {
      changeData();
    });

    // callbacks for lx-selects
    this.specialtyCallback = specialtyCallback;

    function specialtyCallback(_newValue, _oldValue) {
      $scope.vm.changeData();
    }

    function filterSpecialty(swap) {

      $scope.vm.specialty.selectedSpecialty = [];

      if (swap !== 'minus') {

        angular.forEach($scope.vm.specialtyOptions, function(value, key) {
          $scope.vm.specialty.selectedSpecialty.push($scope.vm.specialtyOptions[$scope.vm.specialtyOptions.indexOf(value)]);
        });

      }

    }

    this.healthCareFundCallback = healthCareFundCallback;

    function healthCareFundCallback(_newValue, _oldValue) {
      $scope.vm.changeData();
    }

    function filterHealthCareFund(swap) {

      $scope.vm.healthCareFund.selectedHealthCareFund = [];

      if (swap !== 'minus') {

        angular.forEach($scope.vm.healthCareFundOptions, function(value, key) {
          $scope.vm.healthCareFund.selectedHealthCareFund.push($scope.vm.healthCareFundOptions[$scope.vm.healthCareFundOptions.indexOf(value)]);
        });

      }

    }

    this.patientClassificationCallback = patientClassificationCallback;

    function patientClassificationCallback(_newValue, _oldValue) {
      $scope.vm.changeData();
    }

    function filterPatientClassification(swap) {

      $scope.vm.patientClassification.selectedPatientClassification = [];

      if (swap !== 'minus') {

        angular.forEach($scope.vm.patientClassificationOptions, function(value, key) {
          $scope.vm.patientClassification.selectedPatientClassification.push($scope.vm.patientClassificationOptions[$scope.vm.patientClassificationOptions.indexOf(value)]);
        });

      }

    }

    this.finYearCallback = finYearCallback;

    function finYearCallback(_newValue, _oldValue) {
      setDates(_newValue);
      $scope.vm.changeData();
    }

    function checkParam(param) {

      if (param.length !== 0) {

        return encodeURIComponent(param.join());

      } else {

        return "";

      }

    }

    this.changeData = changeData;

    function changeData() {

      var newUrl = $scope.vm.url
        + '&startDate=' + $scope.vm.startDatePicker.input.dateFormatted
        + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted
        + '&specialty=' + checkParam($scope.vm.specialty.selectedSpecialty)
        + '&healthCareFund=' + checkParam($scope.vm.healthCareFund.selectedHealthCareFund)
        + '&patientClassification=' + checkParam($scope.vm.patientClassification.selectedPatientClassification);

      if ($scope.vm.datatableApi) {
        $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
      }


    }


    // bind the datatable instance to an object to monitor loading
    this.dtInstanceCallback = dtInstanceCallback;

    function dtInstanceCallback(dtInstance) {

      $scope.dtInstance = dtInstance._renderer;

    }

    // bind filter swap
    this.filterSwap = filterSwap;

    function filterSwap(thisFilter, thisModifier) {


      switch (thisFilter) {

        case 'specialty':

          if (thisModifier === 'add') {

            filterSpecialty('add');

          } else {

            filterSpecialty('minus');

          }

          break;

        case 'healthCareFund':

          if (thisModifier === 'add') {

            filterHealthCareFund('add');

          } else {

            filterHealthCareFund('minus');

          }

          break;

        case 'patientClassification':

          if (thisModifier === 'add') {

            filterPatientClassification('add');

          } else {

            filterPatientClassification('minus');

          }

          break;

        default:
          break;
      }

    }


  }
}

export default ReadmissionsController;



// WEBPACK FOOTER //
// ./client/app/common/reports/readmissions/readmissions.controller.js